import i18next from 'i18next'
import common_ru from './ru/common.json'
import common_en from './en/common.json'

i18next.init({
  lng: window.state.locale,
  interpolation: {
    escapeValue: false,
  },
  resources: {
    en: {
      common: common_en,
    },
    ru: {
      common: common_ru,
    },
  },
})

export default i18next
